import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Container, Button } from '../../components/ui';
import { apiUrl } from '../../config/api';

const slugToTitle = (slug) =>
  slug ? slug.split('-').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') : 'Kategori';

export default function KategoriProduk() {
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    Promise.all([
      fetch(apiUrl(`/api/categories/slug/${slug}`)).then((r) => r.json()),
      fetch(apiUrl(`/api/products/by-category/${slug}`)).then((r) => r.json()),
    ])
      .then(([cat, prods]) => {
        if (cancelled) return;
        setCategory(cat && !cat.error ? cat : null);
        setProducts(Array.isArray(prods) ? prods : []);
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [slug]);

  const title = category?.title || slugToTitle(slug);

  return (
    <main className="min-h-screen py-16">
      <Container>
        <h1 className="text-2xl md:text-3xl font-bold text-am-text-900 text-center">{title}</h1>
        {loading ? (
          <p className="mt-4 text-am-text-700 text-center">Memuat...</p>
        ) : (
          <>
            {products.length > 0 ? (
              <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                {products.map((p) => (
                  <div
                    key={p._id}
                    className="rounded-xl border border-am-green-100 bg-white shadow-sm overflow-hidden hover:shadow-md transition-shadow"
                  >
                    {p.imageUrl ? (
                      <a href={p.link || '#'} target="_blank" rel="noopener noreferrer" className="block aspect-square overflow-hidden">
                        <img src={p.imageUrl} alt={p.name} className="w-full h-full object-cover hover:scale-105 transition-transform" />
                      </a>
                    ) : (
                      <div className="aspect-square bg-am-green-50 flex items-center justify-center text-am-text-700 text-sm">
                        No image
                      </div>
                    )}
                    <div className="p-3">
                      <h3 className="font-semibold text-am-text-900 line-clamp-1">{p.name}</h3>
                      {p.link && (
                        <a href={p.link} target="_blank" rel="noopener noreferrer" className="text-xs text-am-accent hover:underline mt-1 inline-block">
                          Lihat
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="mt-4 text-am-text-700 text-center">
                Belum ada produk untuk kategori ini. Kelola produk di dashboard konten.
              </p>
            )}
            <div className="text-center mt-8">
              <Link to="/kategori">
                <Button variant="primary" size="md">Kembali ke Kategori</Button>
              </Link>
            </div>
          </>
        )}
      </Container>
    </main>
  );
}
